import { render, staticRenderFns } from "./DialogNewProject.vue?vue&type=template&id=732175c0"
import script from "./DialogNewProject.vue?vue&type=script&lang=js"
export * from "./DialogNewProject.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports